export default function getMapDefault<T = unknown, K = unknown>(
  map: Map<K, T>,
  key: K,
  def: T
) {
  return map.has(key) ? map.get(key) : def;
}
